import React, { memo, useEffect, useState, ChangeEvent } from 'react';
import closeImage from '@/assets/images/login/inp_close.png';
import luckImage from '@/assets/images/login/code.png';
import checkRight from '@/assets/images/login/pwd_checked.png';
import { Form, Input, Button } from 'antd';
import { useHistory } from 'react-router-dom';
import { apiGetAccountPhoneCode, apiGetCheckPhoneCode } from '../server';
import useCount from '@/hooks/count';
import { isTel } from '@/utils';
import '../index.less';
import { checkPhoneCodeProps } from '@/components/Login/server';
import { lmessage } from '../message';
import classnames from 'classnames';
import HeadBtn from '../components/headBtn';

const COUNT_STATIC = 60;

function LoginVerify() {
  const [form] = Form.useForm();
  const history: any = useHistory();
  const username: any = history.location?.state?.username;
  const [count, beginTimer, closeTimer] = useCount(COUNT_STATIC);
  const [phone, setPhone] = useState<string>('');
  const [phoneText, setPhoneText] = useState<string>('');
  const [canLogin, setCanLogin] = useState<boolean>(false);
  function changeStatus() {
    const formData = form.getFieldsValue();
    if (formData.code) {
      return setCanLogin(true);
    }
    setCanLogin(false);
  }
  const handlePercentMatchCode = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const val = value ? value.replace(/[\D]/g, '') : value;
    form.setFieldsValue({
      code: val
    });
    changeStatus();
  };
  const onTimerClick = () => {
    apiGetAccountPhoneCode({ account: username })
      .then(({ data }) => {
        lmessage.success('验证码成功发送');
        setPhone(data.phone);
        setPhoneText(data.phone);
        beginTimer();
      })
      .catch(data => {
        // console.log(data);
      });
  };
  useEffect(
    () => {
      onTimerClick();
      return () => {
        closeTimer();
      };
    },
    [] // eslint-disable-line react-hooks/exhaustive-deps
  );
  function formSubmit() {
    form.validateFields().then(async formRes => {
      const values = formRes as checkPhoneCodeProps;
      if (!values.code) {
        return lmessage.error('请输入验证码');
      }
      if (values.code.length < 4) {
        return lmessage.error('验证码字符不得低于4位');
      }
      let res: any = await apiGetCheckPhoneCode({ ...values, account: username });
      if (!res.code) res = res.data;
      if (res.code === 200) {
        history.push('/login/reset', { code: values.code, phone: phone, account: username });
      } else {
        lmessage.error(res.msg);
      }
    });
  }
  return (
    <div className="main_position_box">
      <HeadBtn headBtnUser={username} headBtnType={3}></HeadBtn>
      <div className="login-switch_mold">
        <div className="currnt_f">输入验证码</div>
      </div>
      <div className="login-form_box" id="login_drop">
        <Form form={form} onFinish={formSubmit} autoComplete="off">
          <Form.Item name="code" className="check_out_box" style={{ marginBottom: '0px' }}>
            <div>
              <Input
                className="check_input"
                placeholder="验证码"
                maxLength={4}
                allowClear={{ clearIcon: <img className="phone_icon del" src={closeImage} alt="" /> }}
                prefix={<img src={luckImage} className="phone_icon" alt="" />}
                onChange={(e: ChangeEvent<HTMLInputElement>) => handlePercentMatchCode(e)}
              ></Input>
              <Button
                onClick={onTimerClick}
                htmlType="button"
                type="text"
                disabled={COUNT_STATIC !== count}
                className={classnames('check_inline_text checkbox_text active codebox_text codebox_active_text', {
                  codebox_active_text: isTel(form.getFieldsValue().phone) || count !== COUNT_STATIC
                })}
                // className={classnames('check_inline_text checkbox_text active codebox_text', {
                //   codebox_active_text: count !== COUNT_STATIC
                // })}
              >
                {count === COUNT_STATIC ? '获取验证码' : `${count}秒后重发`}
              </Button>
            </div>
          </Form.Item>
          <div className="check_tips check_tips_text" style={{ visibility: phoneText ? 'visible' : 'hidden' }}>
            <img src={checkRight} className="check_icon" alt="" />
            <span className="check_text">已发送4位验证码至 {phoneText}</span>
          </div>
          <Button
            htmlType="submit"
            className={canLogin ? 'login-form_box__submit_button' : 'login-form_box__submit_button disabled'}
          >
            下一步
          </Button>
        </Form>
      </div>
    </div>
  );
}
export default memo(LoginVerify);
